import { HYDRATE } from 'next-redux-wrapper';

import { SET_TV_BOXES } from '../actionTypes/tvboxes';

const initialState = {
    tvBoxes: [],
};

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case HYDRATE:
            return { ...state, ...action.payload.tvBoxes };
        case SET_TV_BOXES:
            return ({
                ...state,
                tvBoxes: [...payload],
            });
        default:
            return state;
    }
};
